import { environment } from '@env/environment';
import * as CryptoJS from 'crypto-js';

export default function criptografar(texto: string): string {
  try {
    if (texto && texto.trim() !== '')
      return CryptoJS.AES.encrypt(
        texto,
        environment.encryptSecretKey
      ).toString();
    else return '';
  } catch (err) {
    return '';
  }
}
